import { useMutation } from '@tanstack/react-query';
import { toast } from '@huspy/forge/shared';
import { proposalApi } from '@modules/proposals/api';
import { CreateProposalESRequestDto } from '@modules/proposals/api/dto/createProposal.dto';
import queryClient from '@app/queryClient';
import { downloadFile } from '@modules/proposals/presentation/utils';
import { trackAmplitudeEvent } from '@shared/analytics/amplitude';
import { USER_EVENTS } from '@shared/analytics/events';

export const useCreateProposalES = () => {
  const {
    error, mutate, isPending, mutateAsync,
  } = useMutation({
    mutationKey: ['createProposalES'],
    mutationFn: (body: CreateProposalESRequestDto) =>
      proposalApi.createProposalEs(body),
    onSuccess: (pdfFile) => {
      downloadFile(pdfFile);
      trackAmplitudeEvent(USER_EVENTS.PROPOSAL.DOWNLOADED, {
        useContext: true,
        addToContext: true,
      });
      queryClient.refetchQueries({ queryKey: ['proposalsListES'] });
      toast('info', { message: 'Proposal created' });
    },
    onError: (e) => {
      toast('error', { message: e.message });
    },
  });

  return {
    mutate, error, isPending, mutateAsync,
  };
};
